export default __webpack_public_path__ + "assets/sad_panda-17d4de4.svg";